import { createContext, useContext } from 'react';
import { type Experiments } from '../types';

export const ExperimentsContext = createContext<Experiments | undefined>(
  undefined,
);

export const useExperiments = () => {
  const experiments = useContext(ExperimentsContext) || {};

  return {
    experiments,
    isExperimentEnabled: (spec: string) =>
      experiments[spec] === true || experiments[spec] === 'true' || false,
  };
};
